import { ArrowRight } from "lucide-react";
import { SERVICES } from "@/data/site";
import { SECTION } from "./styles";

export const Services = () => {
  const preselect = (title) => {
    window.dispatchEvent(new CustomEvent("apex:preselect-service", { detail: title }));
  };

  return (
    <section id="services" data-testid="services-section" className={`${SECTION} bg-[#F4F4F1]`}>
      <div className="mb-16">
        <p className="font-accent-script text-2xl md:text-3xl text-[#D4AF37] mb-3">What We Do</p>
        <h2
          className="font-serif text-3xl md:text-5xl font-semibold text-[#0A1F3C] gold-underline"
          data-testid="services-headline"
        >
          OUR SERVICES
        </h2>
        <p className="text-[#5A6A85] mt-6 max-w-2xl leading-relaxed">
          From single-room updates to whole-home transformations — every service is delivered with
          the same standard of care.
        </p>
      </div>

      <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
        {SERVICES.map((s) => (
          <article
            key={s.id}
            data-testid={`service-card-${s.id}`}
            className="group bg-white border border-[#E2E2DE] shadow-sm hover:border-[#D4AF37] transition-colors duration-300 overflow-hidden flex flex-col"
          >
            <div className="h-48 overflow-hidden">
              <img
                src={s.img}
                alt={s.title}
                loading="lazy"
                className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
              />
            </div>
            <div className="p-6 flex flex-col flex-1">
              <h3 className="font-serif text-xl text-[#0A1F3C] mb-2">{s.title}</h3>
              <p className="text-sm text-[#5A6A85] leading-relaxed flex-1">{s.desc}</p>
              <a
                href="#estimate"
                onClick={() => preselect(s.title)}
                data-testid={`service-estimate-btn-${s.id}`}
                className="mt-5 inline-flex items-center gap-2 text-[11px] uppercase tracking-[0.2em] font-semibold text-[#C9A227] hover:text-[#0A1F3C] transition-colors duration-300"
              >
                Request an Estimate <ArrowRight className="h-4 w-4" />
              </a>
            </div>
          </article>
        ))}
      </div>
    </section>
  );
};
